import { createRef, useState } from "react";

export interface EditTextFieldProps {
    onSave: (value: string) => void;
    value: string;
    title: string | undefined;
    subtitle: string | undefined;
    buttonText: string;
    isSkip?: boolean;
}

const EditTextField = ({ onSave, value, title, subtitle, buttonText, isSkip }: EditTextFieldProps) => {
    const [newTextValue, setNewTextValue] = useState<string>(value);
    const inputRef = createRef<string>();

    const handleSubmit = (event: any) => {
        event.preventDefault();
        onSave(newTextValue);
    };

    const enabled = newTextValue.length > 0;

    return (
        <div className="content_sec wf-section">
            <div className="signup_top_info">
                <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                <h2 className="signup_title">{title}</h2>
                <div>{subtitle}</div>
            </div>
            <div className="login_sec w-form">
                <form onSubmit={handleSubmit}>
                    <div className="form_field_content login">
                        <div className="field_block">
                            <textarea value={newTextValue} placeholder="למשל, תחביבים, תכונות אופי, שאיפות" onChange={e => setNewTextValue(e.target.value)} className="txt_field area w-input"></textarea>
                            {/* <div className="form_allert" style={{ display: errors && errors["text"] ? "contents" : "block" }}>{errors["text"]}</div> */}
                        </div>
                        <br />
                        <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                    </div>

                    {/* <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full send w-button"}></input> */}
                    {isSkip && <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <a href="#" onClick={handleSubmit} className="skip_link">אכתוב בפעם אחרת</a>
                    </div>}
                </form>
            </div>
        </div >
    )
}


export default EditTextField;